import React from 'react';

import { Box, Grid, LoadingBlock } from 'app/shared/components/atoms';
import {
  EventPageDesktopSecondColumn,
  EventPageFirstColumn,
  EventPageGrid,
  FullWidthColumn,
} from 'app/fan/components/templates';

export const EventPageLoadingBlocks = () => {
  return (
    <>
      <EventPageGrid h="100%" w="100%" data-qaid="loading-blocks">
        <EventPageFirstColumn>
          <Box flexDirection="column" gap={10}>
            <LoadingBlock h="100%" w="100%" aspectRatio="16/9" />
            <LoadingBlock h="500px" w="100%" />
          </Box>
        </EventPageFirstColumn>
        <EventPageDesktopSecondColumn>
          <LoadingBlock h="550px" w="100%" />
        </EventPageDesktopSecondColumn>
        <FullWidthColumn pt={6}>
          <Grid
            mobileNumberOfColumns={1}
            tabletNumberOfColumns={2}
            smallDesktopNumberOfColumns={2}
            largeDesktopNumberOfColumns={3}
            mobileGap={5}
            tabletGap={5}
            smallDesktopGap={8}
            largeDesktopGap={5}
            rowGap={8}
          >
            <LoadingBlock w="100%" h="92px" overflow="hidden" />
            <LoadingBlock w="100%" h="92px" overflow="hidden" />
            <LoadingBlock w="100%" h="92px" overflow="hidden" />
          </Grid>
        </FullWidthColumn>
      </EventPageGrid>
    </>
  );
};
